import { types } from './options';

const backValue = (value, type, format = 'YYYYDDMM') => (value && type ? types[type].formater(value, format) : undefined);

export default backValue;
